import { CEExportProjectAttributesBase } from './ce-export-project-attributes-base'


export class CEExportProjectAttributes extends CEExportProjectAttributesBase {

}